module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chat-6f8e95fcef81506bfb22f6389b82f28c.svg";